import { Box, Button, Divider, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import KenColors from '../../../Helpers/Themes/kenColors';
import KenLoader from '../../../GlobalComponents/KenLoader';
import CircleIcon from '@mui/icons-material/Circle';
import { useStyles } from '../../Network/styles';
import { useContext, useEffect, useState } from 'react';
import ChatBox from '../../../GlobalComponents/ChatBox';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import { featuredCardData } from '../../Network/NetworkData';
import TwitterIcon from '@mui/icons-material/Twitter';
import { LinkedIn } from '@mui/icons-material';
import { getMentorshipDetails } from '../../../Utils/apiService';
import { AuthUser } from '../../../interfaces/Contexts';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import React from 'react';
import business from '../../../Assets/business.svg';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import ScheduleCallDialog from './ScheduleCallDialog';
import { sentfriendrequest } from '../../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';
import { useMediaQuery } from '@mui/material';
import P2PChatBox from '../../../GlobalComponents/ChatBox/P2Pchat';
import DefaultSchoolLogo from '../../../Assets/DefaultSchoolLogo.svg';
import DefaultCompanyLogo from '../../../Assets/DefaultCompanyLogo.svg';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps & { style?: React.CSSProperties }) {
  const { children, value, index, style, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }} style={style}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const commonStyles = {
  borderRadius: 1,
  height: 36,
  width: 120,
  textTransform: 'none',
};

const gradientStyle = {
  ...commonStyles,
  background: 'linear-gradient(to right, #FAB400, #FFE090)',
  color: '#5B4200',
  '&:hover': { background: 'linear-gradient(to right, #FAB400, #FFE090)' },
};

const requestedStyle = {
  ...commonStyles,
  background: '#EBF4EC',
  color: '#28652B',
  '&:hover': { background: '#EBF4EC' },
};

const typographyStyles = {
  fontSize: '12px',
  fontWeight: 500,
};

const MentorshipDetails: React.FunctionComponent = () => {
  const location = useLocation();
  const {
    state: { user },
  } = useContext(AuthContext);
  const { mentorshipId } = useParams();
  console.log(mentorshipId, "mentorshipIdmentorshipIdmentorshipId");

  const [loader, setLoader] = useState(false);
  const userData = user as AuthUser;
  console.log(userData?.applicantId, "this is our user contact id");
  console.log(mentorshipId, "this is which user we selected id");


  const data = featuredCardData?.[0];
  const classes = useStyles();
  const [isChatBoxOpen, setChatBoxOpen] = useState(false);
  const [MatchedData, setMatchedData] = useState<any>([]);
  console.log('MatchedData12321', MatchedData);
  const [networkData, setNetworkData] = useState<any>([]);
  const [academicRecordData, setAcademicRecordData] = useState<any[]>([]);
  const [ConnectionRequestId, setConnectionRequestId] = useState<any>(null);
  const [employeeDetails, setEmployeeDetails] = useState<any[]>([]);
  const handleReplyClick = () => {
    setChatBoxOpen(true);
  };
  const sentRequested = () => {
    const payload: any = {
      "Connection_Request_Sent__c": true,
      "Mentee__c": userData?.applicantId,
      "Mentor__c": mentorshipId,
      "RecordTypeId": ConnectionRequestId
    }
    sentfriendrequest(payload).then((res) => {
      console.log('res1234565432', res);
      if (res?.success === true) {
        enqueueSnackbar({
          message: 'Connection Request Sent Successfully',
          variant: 'success',
          autoHideDuration: 1000,
        });
        setLoader(true);
        getMentorshipDetails(userData?.applicantId).then((res) => {
          console.log('res1234565432', res?.data?.data);
          const mentees: any[] = res?.data?.data?.MenteeDetails || [];
          const mentors: any[] = res?.data?.data?.MentorDetails || [];
          const match: any =
            mentees.find(item => item?.contactDetails?.id === mentorshipId) ||
            mentors.find(item => item?.contactDetails?.id === mentorshipId);
          setMatchedData(match);
          setAcademicRecordData(match?.contactDetails?.academicDetails);
          setEmployeeDetails(match?.contactDetails?.employmentDetails);
          const mentorshipTypes = res?.data?.data?.mentorshipTypes || [];
          setConnectionRequestId(
            mentorshipTypes.find((type: any) => type.Name === "Connection_Request")?.Id
          );
          setCallrequestId(
            mentorshipTypes.find((type: any) => type.Name === "Call_Request")?.Id
          );
          setLoader(false)
        });
      } else {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
      }
    })
  };
  const handleChatBoxClose = () => {
    setChatBoxOpen(false);
  };
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [CallrequestId, setCallrequestId] = useState<any>(null);

  useEffect(() => {
    setLoader(true);
    getMentorshipDetails(userData?.applicantId).then((res) => {
      console.log('res1234565432', res?.data?.data);
      const mentees: any[] = res?.data?.data?.MenteeDetails || [];
      const mentors: any[] = res?.data?.data?.MentorDetails || [];
      const match: any =
        mentees.find(item => item?.contactDetails?.id === mentorshipId) ||
        mentors.find(item => item?.contactDetails?.id === mentorshipId);
      setMatchedData(match);
      setAcademicRecordData(match?.contactDetails?.academicDetails);
      setEmployeeDetails(match?.contactDetails?.employmentDetails);
      // Updated logic to get IDs by Name
      const mentorshipTypes = res?.data?.data?.mentorshipTypes || [];
      setConnectionRequestId(
        mentorshipTypes.find((type: any) => type.Name === "Connection_Request")?.Id
      );
      setCallrequestId(
        mentorshipTypes.find((type: any) => type.Name === "Call_Request")?.Id
      );
      setLoader(false);
    });
  }, []);
  const isConnected = MatchedData?.isMentor || MatchedData?.isMentee;
  const requestSent =
    MatchedData?.mentorConnectionRequestSent || MatchedData?.menteeConnectionRequestSent;
  const requestRejected =
    MatchedData?.mentorConnectionRequestRejected || MatchedData?.menteeConnectionRequestRejected;

  // Add date formatting function
  const formatDate = (dateStr: string | undefined) => {
    console.log(dateStr, "dsfbdsjhb");

    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr; // fallback to original if invalid
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const isMobile = useMediaQuery('(max-width:600px)');

  const formatTheYear = (dateStr: string | any): string => {
    if (typeof dateStr === 'string' && dateStr.includes('-')) {
      return dateStr.split('-')[0];
    }
    return '';
  };

  const formatToMonthYear = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleString('default', { month: 'short', year: 'numeric' }); // e.g., Dec 2022
  };

  return (
    <>
      {loader && <KenLoader />}
      <Grid item container>
        <Paper className={`${classes.paperCustom}`}>
          <Grid container>
            <Grid item lg={4} xl={4} md={4} xs={12}>
              <Grid
                container
                sx={{
                  flexDirection: { xs: 'center', md: 'center' },
                  alignItems: { xs: 'center', md: 'center' },
                  justifyContent: { xs: 'center', md: 'flex-start' },
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                <Grid item>
                  <img
                    src={
                      MatchedData?.contactDetails?.profilePicURL
                        ? MatchedData?.contactDetails?.profilePicURL
                        : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0Jnmbf97ZxXsH93k7sfN275-TTdLcJ8XRyZ6aDznLSAzwjPBw7GLYOTo46aX5YVz3eCI&usqp=CAU'
                    }
                    alt={networkData?.Name}
                    className={classes.eventBanner}
                    style={{ borderRadius: '50%', width: 80, height: 80, marginBottom: 8 }}
                  />
                </Grid>

                <Grid
                  item
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  className={classes.cardDesign}
                >
                  <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>
                    {MatchedData?.contactDetails?.name}
                  </Typography>

                  <Typography mt={1} fontSize={14} fontWeight={500}>
                    {MatchedData?.contactDetails?.designation}
                  </Typography>

                  <Typography mt={1} fontSize={14} width={220} display="flex" alignItems="center" justifyContent={{ xs: 'center', md: 'flex-start' }}>
                    {MatchedData?.contactDetails?.employmentDetails?.[0]?.Company__r?.Name && (
                      <img
                        src={
                          MatchedData?.contactDetails?.employmentDetails?.[0]?.Company__r?.Logo_File_URL__c
                            ? MatchedData?.contactDetails?.employmentDetails?.[0]?.Company__r?.Logo_File_URL__c.replace(/&amp;/g, '&')
                            : DefaultCompanyLogo
                        }
                        alt=""
                        style={{ height: 23, width: 23, marginRight: 5 }}
                      />
                    )}
                    {MatchedData?.contactDetails?.employmentDetails?.[0]?.Company__r?.Name}
                    {MatchedData?.contactDetails?.employmentDetails?.[0]?.Location__c
                      ? `, ${MatchedData?.contactDetails?.employmentDetails?.[0]?.Location__c}`
                      : ''}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={5.8} xl={5.8} md={5.8} xs={12} display="flex" flexDirection="column" justifyContent="center" alignItems="flex-start">
              {!isMobile ? (
                // ----------- Desktop / Tablet View -----------
                <>
                  <Grid container style={{ fontSize: "14px", color: "#8C8E94" }}>
                    {/* Batch of */}
                    <Grid item lg={3} xl={3} md={3} xs={5}>
                      <Typography fontWeight={500}>Batch of</Typography>
                      <Typography width={"100%"} color={"#373A45"} fontWeight={500}>
                        {MatchedData?.contactDetails?.academicDetails?.[0]?.Field_of_study__c}
                        {MatchedData?.contactDetails?.academicDetails?.[0]?.Field_of_study__c ? ", " : ""}
                        {MatchedData?.contactDetails?.batch}
                      </Typography>
                    </Grid>

                    {/* Email */}
                    <Grid item lg={4.5} xl={4.5} md={4.5} xs={5}>
                      <Typography fontWeight={500}>Email</Typography>
                      <Typography width={"100%"} color={"#373A45"} fontWeight={500}>
                        {MatchedData?.contactDetails?.email || "a*****@gmail.com"}
                      </Typography>
                    </Grid>

                    {/* Current Location */}
                    <Grid item lg={4} xl={4} md={3.5} xs={5}>
                      <Typography fontWeight={500}>Current Location</Typography>
                      <Typography color={"#373A45"} fontWeight={500}>
                        {MatchedData?.contactDetails?.city}
                        {MatchedData?.contactDetails?.city ? ", " : ""}
                        {MatchedData?.contactDetails?.country || "-"}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container mt={2} style={{ fontSize: "14px", color: "#8C8E94" }}>
                    {/* Expertise */}
                    <Grid item lg={3} xl={3} md={3} xs={5}>
                      <Typography fontWeight={500}>Expertise</Typography>
                      <Typography color={"#373A45"} fontWeight={500}>2023</Typography>
                    </Grid>

                    {/* Phone Number */}
                    <Grid item lg={4.5} xl={4.5} md={4.5} xs={5}>
                      <Typography fontWeight={500}>Phone number</Typography>
                      <Typography color={"#373A45"} fontWeight={500}>
                        {MatchedData?.contactDetails?.phone || "+91 99*****19"}
                      </Typography>
                    </Grid>

                    {/* Social Connect */}
                    <Grid item lg={3.5} xl={3.5} md={3.5} xs={5}>
                      <Typography fontWeight={500}>Social connect</Typography>
                      <div className={`${classes.eventDetailsTypo} scrollbar-cusgray`}>
                        {MatchedData?.contactDetails?.Facebook_URL__c && (
                          <a
                            href={MatchedData?.contactDetails?.Facebook_URL__c.startsWith("http") ? MatchedData.contactDetails.Facebook_URL__c : `https://${MatchedData.contactDetails.Facebook_URL__c}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FacebookRoundedIcon style={{ color: 'white', backgroundColor: '#3C5A9A', borderRadius: '50%', padding: 5, marginRight: 5 }} />
                          </a>
                        )}

                        {networkData?.Twitter_URL__c && (
                          <a
                            href={networkData.Twitter_URL__c.startsWith("http") ? networkData.Twitter_URL__c : `https://${networkData.Twitter_URL__c}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <TwitterIcon style={{ color: 'white', backgroundColor: '#5DA8DC', borderRadius: '50%', padding: 5 }} />
                          </a>
                        )}

                        {MatchedData?.contactDetails?.linkedInUrl && (
                          <a
                            href={MatchedData.contactDetails.linkedInUrl.startsWith("http") ? MatchedData.contactDetails.linkedInUrl : `https://${MatchedData.contactDetails.linkedInUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LinkedIn style={{ color: 'white', backgroundColor: '#5DA8DC', borderRadius: '50%', padding: 5 }} />
                          </a>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </>
              ) : (
                // ----------- Mobile View with Single Box and Dividers -----------
                <Grid container direction="column" style={{
                  backgroundColor: "#F6F8FB",
                  padding: "10px",
                  borderRadius: "12px",
                  marginTop: '20px'
                }}>
                  {[
                    { label: "Batch of", value: `${MatchedData?.contactDetails?.academicDetails?.[0]?.Field_of_study__c || ""}${MatchedData?.contactDetails?.academicDetails?.[0]?.Field_of_study__c ? ", " : ""}${MatchedData?.contactDetails?.batch || ""}` },
                    { label: "Email", value: MatchedData?.contactDetails?.email || "a*****@gmail.com" },
                    { label: "Current Location", value: `${MatchedData?.contactDetails?.city || ""}${MatchedData?.contactDetails?.city ? ", " : ""}${MatchedData?.contactDetails?.country || "-"}` },
                    { label: "Expertise", value: "2023" },
                    { label: "Phone number", value: MatchedData?.contactDetails?.phone || "+91 99*****19" },
                    {
                      label: "Social connect", value: (
                        <div className={`${classes.eventDetailsTypo} scrollbar-cusgray`}>
                          {MatchedData?.contactDetails?.Facebook_URL__c && (
                            <a
                              href={MatchedData.contactDetails.Facebook_URL__c.startsWith("http") ? MatchedData.contactDetails.Facebook_URL__c : `https://${MatchedData.contactDetails.Facebook_URL__c}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FacebookRoundedIcon style={{ color: 'white', backgroundColor: '#3C5A9A', borderRadius: '50%', padding: 5, marginRight: 5 }} />
                            </a>
                          )}
                          {networkData?.Twitter_URL__c && (
                            <a
                              href={networkData.Twitter_URL__c.startsWith("http") ? networkData.Twitter_URL__c : `https://${networkData.Twitter_URL__c}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <TwitterIcon style={{ color: 'white', backgroundColor: '#5DA8DC', borderRadius: '50%', padding: 5 }} />
                            </a>
                          )}
                          {MatchedData?.contactDetails?.linkedInUrl && (
                            <a
                              href={MatchedData.contactDetails.linkedInUrl.startsWith("http") ? MatchedData.contactDetails.linkedInUrl : `https://${MatchedData.contactDetails.linkedInUrl}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <LinkedIn style={{ color: 'white', backgroundColor: '#5DA8DC', borderRadius: '50%', padding: 5, marginLeft: 5 }} />
                            </a>
                          )}
                        </div>
                      )
                    }
                  ].map((item, index, arr) => (
                    <div
                      key={index}
                      style={{
                        padding: "16px 0",
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start',  // 👈 makes everything left-aligned
                        borderBottom: index !== arr.length - 1 ? '0.5px solid #E6E6E8' : 'none',
                      }}
                    >
                      <Typography fontWeight={500} color="#8C8E94" style={{ marginBottom: 4 }}>
                        {item.label}
                      </Typography>
                      <Typography fontWeight={500} color="#373A45" style={{ marginLeft: 20, flex: 1 }}>
                        {item.value}
                      </Typography>
                    </div>
                  ))}
                </Grid>
              )}
            </Grid>

            <Grid
              item
              lg={2.2}
              xl={2.2}
              md={2.2}

              display="flex"
              justifyContent="flex-end"
              alignItems="flex-end"
              sx={{
                mt: { xs: 2.5, md: 0 },
              }}
            >
              <Button
                size="large"
                onClick={handleReplyClick}
                sx={{
                  borderRadius: 1,
                  marginRight: 1,
                  height: 36,
                  width: 120,
                  background: '#E8EBF3',
                  color: '#373A45',
                  textTransform: 'none',
                  '&:hover': {
                    background: '#E8EBF3', // maintain gradient on hover
                  }
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                >
                  Message
                </Typography>
              </Button>
              {isConnected ? (
                <Button size="large" onClick={() => setDialogOpen(true)} sx={gradientStyle}>
                  <Typography sx={typographyStyles}>Schedule a call</Typography>
                </Button>
              ) : requestSent && !requestRejected ? (
                <Button size="large" sx={requestedStyle}>
                  <Typography sx={typographyStyles}>Requested</Typography>
                  <DoneOutlinedIcon style={{ color: '#28652B', padding: '3px' }} />
                </Button>
              ) : (
                <Button size="large" onClick={sentRequested} sx={gradientStyle}>
                  <Typography sx={typographyStyles}>Connect</Typography>
                  <AddOutlinedIcon style={{ padding: '3px' }} />
                </Button>
              )}
            </Grid>
          </Grid>
        </Paper>
        <Grid container sx={{ 
          textAlign: "left", 
          // height: "64.8vh",
          // '@media (min-width: 1530px) and (max-width: 1740px)': {
          //   height: "54.8vh" 
          // },
          // '@media (min-width: 1740px) and (max-width: 1980px)': {
          //   height: "64.8vh" 
          // },
          
        }}>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8} style={{ backgroundColor: "white", marginTop: "15px", padding: "0px 15px", borderRadius: "8px" }} sx={{ 
          textAlign: "left", 
          height: "65vh",
          '@media (min-width: 1440px) and (max-width: 1540px)': {
            height: "61vh" 
          },
          '@media (min-width: 1540px) and (max-width: 1710px)': {
            height: "53vh" 
          },
          '@media (min-width: 1710px) and (max-width: 1920px)': {
            height: "64.3vh" 
          },
          '@media (min-width: 1920px) and (max-width: 2080px)': {
            height: "63.3vh" 
          },
          
        }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs TabIndicatorProps={{
                style: {
                  backgroundColor: '#FAB400'
                },
              }} value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab
                  label="Personal Details"
                  {...a11yProps(0)}
                  sx={{
                    textTransform: 'none',
                    '&.Mui-selected': {
                      color: '#373A45', // or use theme color like '#FFC107'
                    }
                  }}
                />
                <Tab
                  label="Can help with"
                  {...a11yProps(1)}
                  sx={{
                    textTransform: 'none',
                    '&.Mui-selected': {
                      color: '#373A45',
                    }
                  }}
                />
                <Tab
                  label="Needs help with"
                  {...a11yProps(2)}
                  sx={{
                    textTransform: 'none',
                    '&.Mui-selected': {
                      color: '#373A45',
                    }
                  }}
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0} style={{ padding: '16px', overflowY: 'auto', height: '44vh', overflowX: 'hidden',scrollbarWidth: "thin",scrollbarColor: "#D1D5DB transparent" }}>
              <Box>
                <Box className={`${classes.detailsBox} `} >
                  {academicRecordData?.length > 0 && (
                    <Grid item xs={12} md={12}>
                      <Typography
                        sx={{
                          fontSize: '16px',
                          fontWeight: '500',
                          marginBottom: '12px',
                          color: "#585A64",
                          lineHeight: '28px',
                          padding: '4px'
                        }}
                      >
                        Education
                      </Typography>
                      {academicRecordData?.map((data: any, index: number) => {
                        // Determine grade display logic
                        const gradeValue = data?.Grade__c;
                        let gradeDisplay = null;
                        if (typeof gradeValue === 'string' && gradeValue.trim() !== '') {
                          // Check if it's a number (percentage)
                          if (!isNaN(Number(gradeValue))) {
                            gradeDisplay = (
                              <Typography style={{ backgroundColor: "#FDE4B1", padding: "6px 8px", borderRadius: "12px", textAlign: "center", fontSize: "13px", float: "right", fontWeight: 500 }}>
                                Percentage : {gradeValue}
                              </Typography>
                            );
                          } else {
                            // It's a letter grade
                            gradeDisplay = (
                              <Typography style={{ backgroundColor: "#FDE4B1", padding: "6px 8px", borderRadius: "12px", textAlign: "center", fontSize: "13px", float: "right", fontWeight: 500 }}>
                                Grade : {gradeValue}
                              </Typography>
                            );
                          }
                        }
                        return (
                          <Grid container style={{ backgroundColor: "#F6F8FB", borderRadius: "12px", padding: "12px" }} justifyContent={"center"} alignItems={"start"} marginTop={index === 0 ? "0px" : "12px"}>
                            <Grid item xs={12} md={1.5} lg={1.5} xl={1.5}>
                              <img alt='' src={data?.Company__r?.Logo_File_URL__c ? data?.Company__r?.Logo_File_URL__c.replace(/&amp;/g, '&') : DefaultSchoolLogo} style={{ height: 70, width: 70, borderRadius: 12 }} />
                            </Grid>
                            <Grid item xs={12} md={9} lg={9} xl={9}>
                              <Box className={classes.eventDetailsHeadingSubContainer} key={index}>
                                <Typography className={classes.eventDetailsHeadingTypo} color={"#373A45"}>{data?.Name_of_the_institute__r?.Name}</Typography>
                                <div className={`${classes.eventDetailsTypo2} scrollbar-cusgray`} style={{ color: "#373A45", fontWeight: "600" }}>{data?.Field_of_study__c}</div>
                                <Typography className={classes.eventDetailsHeadingTypo} style={{ marginTop: 12 }}>
                                  {formatTheYear(data?.Start_Date__c)} - {formatTheYear(data?.End_Date__c)}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} md={1.5} lg={1.5} xl={1.5}>
                              {gradeDisplay}
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  )}
                  {employeeDetails?.length > 0 && (
                    <Grid item xs={12} md={12}>
                      <Typography
                        sx={{
                          fontSize: '16px',
                          fontWeight: '500',
                          margin: '12px 0px',

                          color: "#585A64",
                          lineHeight: '28px',
                        }}
                      >
                        Work Experience
                      </Typography>
                      {employeeDetails?.map((data: any, index: number) => {
                        return (
                          <Grid container style={{ backgroundColor: "#F6F8FB", borderRadius: "12px", padding: "12px" }} justifyContent={"center"} alignItems={"start"} marginTop={index === 0 ? "0px" : "12px"}>
                            <Grid item xs={12} md={1.5} lg={1.5} xl={1.5}>
                              <img alt='' src={data?.Company__r?.Logo_File_URL__c ? data?.Company__r?.Logo_File_URL__c.replace(/&amp;/g, '&') : DefaultCompanyLogo} style={{ height: 70, width: 70, borderRadius: 12 }} />
                            </Grid>
                            <Grid item xs={12} md={8} lg={8} xl={8}>
                              <Box className={classes.eventDetailsHeadingSubContainer} key={index}>
                                <div className={classes.eventDetailsHeadingTypo} style={{ color: "#373A45", fontWeight: "400" }}>{data.Title__c}</div>
                                <Typography className={`${classes.eventDetailsTypo2} scrollbar-cusgray`} style={{ color: "#373A45", fontWeight: "600" }}>
                                  {`${data?.Company__r?.Name ?? ''}${data?.Employment_Type__c ? ` | ${data.Employment_Type__c}` : ''}`}

                                </Typography>
                                <Typography className={classes.eventDetailsHeadingTypo} style={{ marginTop: 12 }}>
                                  {`${data?.Location__c ?? ''}${data?.Location_Type__c ? ` | ${data.Location_Type__c}` : ''}`}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} md={2.5} lg={2.5} xl={2.5}>
                              {
                                data?.Start_Date__c && (
                                  <Typography style={{ backgroundColor: "#FDE4B1", padding: "6px 8px", borderRadius: "12px", textAlign: "center", fontSize: "13px", float: "right", fontWeight: 500 }}>
                                    <>
                                      {formatToMonthYear(data?.Start_Date__c)} - {data?.End_Date__c ? formatToMonthYear(data?.End_Date__c) : "Present"}
                                    </>

                                  </Typography>
                                )
                              }
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  )}
                </Box>
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Grid>
                    <Typography color={"#585A64"} fontSize={"16px"} fontWeight={"500"} mb={2}>Willingness to mentor</Typography>
                  </Grid>
                  <Grid>
                    <Typography style={{ display: "flex", alignItems: "center", marginTop: 15, backgroundColor: "#F6F8FB", padding: "10px 15px", borderRadius: "5px" }}>
                      <CircleIcon style={{ fontSize: "5px", marginRight: 10 }} /> Host an alumni event
                    </Typography>
                    <Typography style={{ display: "flex", alignItems: "center", marginTop: 15, backgroundColor: "#F6F8FB", padding: "10px 15px", borderRadius: "5px" }}>
                      <CircleIcon style={{ fontSize: "5px", marginRight: 10 }} /> Be a batch/regional ambassador
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Grid>
                    <Typography color={"#585A64"} fontSize={"16px"} fontWeight={"500"} mb={2}>Willingness to mentor</Typography>
                  </Grid>
                  <Grid>
                    <Typography style={{ display: "flex", alignItems: "center", marginTop: 15, backgroundColor: "#F6F8FB", padding: "10px 15px", borderRadius: "5px" }}>
                      <CircleIcon style={{ fontSize: "5px", marginRight: 10 }} /> Host an alumni event
                    </Typography>
                    <Typography style={{ display: "flex", alignItems: "center", marginTop: 15, backgroundColor: "#F6F8FB", padding: "10px 15px", borderRadius: "5px" }}>
                      <CircleIcon style={{ fontSize: "5px", marginRight: 10 }} /> Be a batch/regional ambassador
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </CustomTabPanel>
          </Grid>
          <Grid item xs={12} sm={12} md={3.8} lg={3.8} xl={3.8} sx={{
            backgroundColor: "white", marginTop: "15px", padding: "23px", borderRadius: "8px", marginLeft: isMobile ? "0px" : "18px",
            '@media (min-width: 1240px) and (max-width: 1280px)': {
              marginLeft: 2,
            },
          }}>
            <Box>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: '500',
                  color: KenColors.ClientBlack,
                }}
              >
                <img src={business} alt='' style={{ marginRight: 10 }} /> About {networkData?.Name}
              </Typography>
              <hr style={{ opacity: "0.14" }} />
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: '400',
                  lineHeight: '22px',
                  marginTop: '10px',
                }}
              >
                {MatchedData?.contactDetails?.personalOverview}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      {isChatBoxOpen && (
        <P2PChatBox
          onClose={handleChatBoxClose}
          name={MatchedData?.contactDetails?.name}
          avatarImg={MatchedData?.contactDetails?.profilePicURL}
          mentordetails={{
            userId: userData?.applicantId,
            otherUserId: mentorshipId,
            chatid: MatchedData?.contactDetails?.chatid // If available, else undefined
          }}
        />
      )}
      <ScheduleCallDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        userData={MatchedData}
        CallrequestId={CallrequestId}
      />
    </>
  );
};

export default MentorshipDetails;
